export default String.raw`
@media screen and (max-width: 767px) {
    .refunds-page-title {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 16px;
    }

    .refunds-container {
        gap: 24px;
        margin-bottom: 24px;
    }

    .refunds-info {
        max-width: 100%;
        gap: 12px;

        &__title {
            font-size: 18px;
            line-height: 24px;
        }

        &__intro {
            font-size: 14px;
            line-height: 22px;
        }
    }

    .refunds-steps {
        &__item {
            align-items: flex-start;
            gap: 10px;
        }

        &__number {
            width: 28px;
            height: 28px;
            font-size: 13px;
        }

        &__text {
            font-size: 13px;
            line-height: 20px;
            padding-top: 3px;
        }
    }

    .refunds-cta {
        padding: 24px;

        &__title {
            font-size: 20px;
            line-height: 28px;
        }

        &__description {
            font-size: 14px;
            line-height: 22px;
        }
    }

    .refund-form {
        padding: 24px;

        &__header {
            margin-bottom: 24px;
        }

        &__title {
            font-size: 20px;
            line-height: 28px;
        }

        &__description {
            font-size: 13px;
            line-height: 18px;
        }

        &__login-info {
            font-size: 13px;
        }
    }
}
`